import {Language} from "@/api/data-contracts";
import {CommonI18N} from "@/translations";

export type LanguageSelectOption = { label: string; value: Language };

/**
 * Maps the available languages (see `useAvailableLanguages` in `datacaches.ts`) to
 * `SelectInputField` options, translating each language's display label via the given
 * translate function. Extracted as a pure `.ts` helper so the mapping is unit-testable without
 * rendering `UserPage.tsx` (project convention: no rendered `.tsx` unit tests, see
 * `.claude/rules/common-testing.md`).
 */
export function toLanguageSelectOptions(
    languages: Language[],
    translate: (key: string) => string
): LanguageSelectOption[] {
    return languages.map((language) => ({
        label: translate(CommonI18N.enum.language[language]),
        value: language
    }));
}
